import modalSlice from './modalSlice';

export const { openModal, closeModal, updateIncidentModalData } =
  modalSlice.actions;

export * from './types';

export default modalSlice.reducer;
